import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69ea48f663911b0014c1aa10/careflow/src/app/page.tsx");
